import { UserShape } from '_types/User';
import {
    getLanguageAndCurrencyConfig,
    ShopifyLanguageCodes,
    ShopifyLanguages,
} from 'Components/Shopify/Utils/utils';

/**
 * Hook that provides language and currency configuration for Shopify operations.
 * Derives appropriate language and country settings from user preferences.
 * @param {Pick<UserShape, 'preferred_language' | 'country'>} [user] - User object with language and country preferences
 * @returns {object} Configuration object with language, countryCode, and shopifyLanguageCode
 */
export const useLanguageAndCurrencyConfig = (
    user?: Pick<UserShape, 'preferred_language' | 'country'>,
): {
    language: ShopifyLanguages;
    countryCode: string;
    shopifyLanguageCode: ShopifyLanguageCodes;
} => {
    const { language, countryCode } = getLanguageAndCurrencyConfig(user);

    return {
        language,
        countryCode,
        shopifyLanguageCode: language === 'NB' ? 'nb' : 'en',
    };
};
